module.exports = __webpack_public_path__ + "img/houseboat-image.98dfb109.jpg";